<template>
  <billing-Layout>
    <slot>
      <div class="page-breadcrumb">
        <div class="row">
          <div class="col-5 align-self-center">
            <h4 class="page-title">Setting TERMS</h4>
          </div>
          <div class="col-7 align-self-center">
            <div class="d-flex align-items-right justify-content-end">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link :to="'/setting'" class="btn btn-info btn-sm mr-2"><i class="fas fa-arrow-left"></i> Back</router-link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>      
      <div class="container-fluid">
        <div class="row">
          <div class="col-6 offset-md-3">           
            <component :is="SettingBox"></component>
          </div>
        </div>
      </div>
    </slot>
  </billing-Layout> 
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import Terms from '@/components/billing/setting/Terms.vue';
export default {
  components:{
    BillingLayout,
    Loader,
    Terms
  },
  data() {
    return {
      isLoadingTerms : false,
      configtermsList: [],
      TermsLists :[],
      term_id : 0,
      NoRecordTerms : false,
      SettingBox : 'Terms' 
    }
  },
  mounted(){
  },
  methods:{
  }
};
</script>
<style>

</style>


